import mitt, { Emitter } from "mitt";
import type { StakingKATRewardWithMeta } from "@/types/network";

export type StakeInfo = {
  validatorId: string;
  amount: number;
  address: string;
};

export type UnStakeBatchInfo = {
  validatorId: string;
  tokenIds: string[];
  address: string;
};

export type ClaimStakerBatchInfo = {
  tokenIds: string[];
  address: string;
};

export type ClaimClaimerInfo = {
  epoch: number;
  address: string;
  reward: StakingKATRewardWithMeta;
};

export type ClaimValidatorInfo = {
  validatorId: string;
  address: string;
  reward: StakingKATRewardWithMeta;
};

export type ClaimLieutenantInfo = {
  epochs: number[];
  address: string;
  reward: StakingKATRewardWithMeta;
};

export type UpdateCaptainDescriptionInfo = {
  description: string;
  tokenId: string;
};

export type UpdateCaptainAvatarInfo = {
  avatar: string;
  tokenId: string;
};

export type UpdateCaptainInfo = {
  avatar?: string;
  tokenId: string;
  description?: string;
  name?: string;
};

export type TwitterConnected = {};

type Events = {
  stakeSuccess: StakeInfo;
  unStakeBatchSuccess: UnStakeBatchInfo;
  claimStakerBatch: ClaimStakerBatchInfo;
  claimClaimer: ClaimClaimerInfo;
  claimValidator: ClaimValidatorInfo;
  claimLieutenant: ClaimLieutenantInfo;
  updateCaptainDescription: UpdateCaptainDescriptionInfo;
  updateCaptainAvatar: UpdateCaptainAvatarInfo;
  updateCaptainInfo: UpdateCaptainInfo;
  twitterConnected: TwitterConnected;
};

const events: Emitter<Events> = mitt();

export default events;
